import { createSelector } from 'reselect'

export const adCreativeTemplateIdSelector = (state) =>
  (state.facebookAds && state.facebookAds.adCreativeTemplateId) || {}
export const adSetTemplateIdSelector = (state) =>
  (state.facebookAds && state.facebookAds.adSetTemplateId) || null
export const adTemplateIdSelector = (state) =>
  (state.facebookAds && state.facebookAds.adTemplateId) || {}
export const adCreativeTemplatesSelector = (state) =>
  (state.facebookAds && state.facebookAds.adCreativeTemplates) || {}
export const adCreativeTemplatePreviewsSelector = (state) =>
  (state.facebookAds && state.facebookAds.adCreativeTemplatePreviews) || {}
export const callsToActionSelector = (state) =>
  (state.facebookAds && state.facebookAds.callsToAction) || {}
export const channelCampaignsSelector = (state) =>
  (state.facebookAds && state.facebookAds.channelCampaigns) || {}
export const targetingSelector = (state) =>
  (state.facebookAds && state.facebookAds.targeting) || {}
export const facebookAdSelector = (state) => state.facebookAds
export const adSetTemplatesSelector = (state) =>
  (state.facebookAds && state.facebookAds.adSetTemplates) || {}
export const facebookAdActivationStatusByIdSelector = (state) =>
  (state.facebookAds && state.facebookAds.activateCampaignRequestsById) || {}
export const createAdVideoRequestsSelector = (state) =>
  (state.facebookAds && state.facebookAds.createAdVideoRequestsByBrandId) || {}
export const getAdVideoRequestsSelector = (state) =>
  (state.facebookAds && state.facebookAds.getAdVideoRequests) || {}
export const adVideoSelector = (state) =>
  (state.facebookAds && state.facebookAds.adVideo) || {}
export const getRetailerAdCreativeTemplatesSelector = (state, id, retailerId) =>
  state.facebookAds &&
  state.facebookAds.retailerAdCreativeTemplates[`${retailerId}-${id}`]

export const callsToActionListSelector = createSelector(
  [callsToActionSelector],
  (callsToAction) => {
    const ctaList = []
    for (let key in callsToAction) {
      if (
        callsToAction.hasOwnProperty(key) &&
        callsToAction[key].status === 'active'
      ) {
        ctaList.push(callsToAction[key])
      }
    }
    return ctaList
  },
)

/**
 * Sort by display value
 * @param a
 * @param b
 * @returns {number}
 */
const callsToActionSort = (a, b) => {
  if (a.value > b.value) {
    return 1
  }
  if (a.value < b.value) {
    return -1
  }
  return 0
}

export const sortedCallsToActionListSelector = createSelector(
  [callsToActionListSelector],
  (callsToAction) => {
    return callsToAction.slice().sort(callsToActionSort)
  },
)

export const selectAdCreativeTemplateId = createSelector(
  [adCreativeTemplateIdSelector],
  (adCreativeTemplateId) => {
    return {
      adCreativeTemplateId,
    }
  },
)

export const selectAdSetTemplateId = createSelector(
  [adSetTemplateIdSelector],
  (adSetTemplateId) => {
    return {
      adSetTemplateId,
    }
  },
)

export const selectAdTemplateId = createSelector(
  [adTemplateIdSelector],
  (adTemplateId) => {
    return {
      adTemplateId,
    }
  },
)

export const selectAdCreativeTemplates = createSelector(
  [adCreativeTemplatesSelector],
  (adCreativeTemplates) => {
    return {
      adCreativeTemplates,
    }
  },
)

export const selectAdCreativeTemplatePreviews = createSelector(
  [adCreativeTemplatePreviewsSelector],
  (adCreativeTemplatePreviews) => {
    return {
      adCreativeTemplatePreviews,
    }
  },
)

export const selectCallsToAction = createSelector(
  [sortedCallsToActionListSelector],
  (callsToAction) => {
    return {
      callsToAction,
    }
  },
)

export const selectChannelCampaigns = createSelector(
  [channelCampaignsSelector],
  (channelCampaigns) => {
    return {
      channelCampaigns,
    }
  },
)

export const selectTargeting = createSelector(
  [targetingSelector],
  (targeting) => {
    return {
      targeting,
    }
  },
)

export const selectCreateAdCreateTemplateState = createSelector(
  [facebookAdSelector],
  (facebookAds) => {
    return {
      createAdCreateTemplateState: {
        status: facebookAds.createAdCreateTemplateStatus,
        errors: facebookAds.createAdCreateTemplateErrors,
      },
    }
  },
)

export const selectCreateAdSetTemplateState = createSelector(
  [facebookAdSelector],
  (facebookAds) => {
    return {
      createAdSetTemplateState: {
        status: facebookAds.createAdSetTemplateStatus,
        errors: facebookAds.createAdSetTemplateErrors,
      },
    }
  },
)

export const selectCreateAdTemplateState = createSelector(
  [facebookAdSelector],
  (facebookAds) => {
    return {
      createAdTemplateState: {
        status: facebookAds.createAdTemplateStatus,
        errors: facebookAds.createAdTemplateErrors,
      },
    }
  },
)

export const selectAdSetTemplates = createSelector(
  [adSetTemplatesSelector],
  (adSetTemplates) => {
    return {
      adSetTemplates,
    }
  },
)

export const selectFacebookAdActivationStatuses = createSelector(
  [facebookAdActivationStatusByIdSelector],
  (activationStatuses) => {
    return {
      activationStatuses,
    }
  },
)
